import React, { useEffect } from 'react';
import { useHistory, Switch, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { paths } from '.';
import { getToken, fetchSignIn, getAndSaveUser } from 'services/auth';

import { fetchGetUserDataByDocumento } from 'store/fetchActions/fetchUsuario';

import Header from 'components/HeaderESefaz/index';
import Menu from 'components/Menu';

import PageAutenticacao from 'pages/Autenticacao';
import PageHomeSupervisor from 'pages/HomeSupervisor';
import PageHomeAtendente from 'pages/HomeAtendente';
import PageCadastrarAtendente from 'pages/Atendente/Cadastrar';
import PageEditarAtendente from 'pages/Atendente/Editar';
import PageListarAtendente from 'pages/Atendente/Listar';
import PageVisualizarAtendente from 'pages/Atendente/Visualizar';
import PageRequerimento from 'pages/Requerimentos/Listar';
import PageRequerimentoListarContribuinte from 'pages/Requerimentos/ListarContribuinte';
import PageDetalhar from 'pages/Requerimentos/Detalhar';
import PageDicionario from 'pages/Dicionario/index';
import PageServicosCadastrar from 'pages/ServicoSistema/Cadastrar/index';
import PageServicosListar from 'pages/ServicoSistema/Listar/index';
import PageServicosDetalhar from 'pages/ServicoSistema/Detalhar/index';
import PageServicosEditar from 'pages/ServicoSistema/Editar/index';
import PageSetorCadastrar from 'pages/SetorSistema/Cadastrar/index';
import PageSetorListar from 'pages/SetorSistema/Listar/index';
import PageSetorEditar from 'pages/SetorSistema/Editar/index';
import PageSetorDetalhar from 'pages/SetorSistema/Detalhar/index';
import PagePostosAtendimentoCadastrar from 'pages/PostosAtendimento/Cadastrar/index';
import PagePostosAtendimentoListar from 'pages/PostosAtendimento/Listar/index';
import PagePostosAtendimentoEditar from 'pages/PostosAtendimento/Editar/index';
import PagePostosAtendimentoDetalhar from 'pages/PostosAtendimento/Detalhar/index';
import PageRelatorioStatus from 'pages/Relatorios/status';
import PageListarRequerimentos from 'pages/Relatorios/listarRequerimentos';
import PageRelatorioSolicitacoes from 'pages/Relatorios/solicitacoes';
import PageRelatorioTipo from 'pages/Relatorios/tipo';
import PageRelatorioPerformanceGeral from 'pages/Relatorios/performanceGeral';
import PageRelatorioPerformanceAtendente from 'pages/Relatorios/performanceAtendente';
import PageDadosCadastraisCadastrar from 'pages/DadosCadastrais/Cadastrar';
import PageDadosCadastrais from 'pages/DadosCadastrais';
import PageDadosCadastraisVisualizar from 'pages/DadosCadastrais/Visualizar';
import PageDadosCadastraisEditar from 'pages/DadosCadastrais/Editar';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { changeShowLibras } from 'utils/acessibilidade';

export default function Private() {
  const dispatch = useDispatch();
  const history = useHistory();

  const authenticated = !!getToken();

  const atendenteLogado = useSelector(state => state.atendente.atendenteLogado);
  const contribuinteLogado = useSelector(state => state.dadosCadastrais.contribuinteLogado);
  const user = useSelector(state => state.sefaz.userProfile);

  useEffect(() => {
    if (!authenticated) fetchSignIn();
  }, [dispatch, authenticated, history]);

  React.useEffect(() => {
    if (!user) dispatch(getAndSaveUser());
    changeShowLibras(user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE);
  }, [dispatch, user]);

  React.useEffect(() => {
    dispatch(fetchGetUserDataByDocumento(user?.cpf_cnpj, atendenteLogado, contribuinteLogado));
    // eslint-disable-next-line
  }, [dispatch]);

  if (!authenticated) return <PageAutenticacao />;

  return (
    <>
      <Header />
      <Menu />
      <Switch>
        <Route path={paths.relatorioPerformanceGeral} exact component={PageRelatorioPerformanceGeral} />
        <Route path={`${paths.relatorioPerformanceAtendente}`} exact component={PageRelatorioPerformanceAtendente} />
        <Route
          path={`${paths.relatorioPerformanceAtendente}/:isSetorial`}
          exact
          component={PageRelatorioPerformanceAtendente}
        />
        <Route path={paths.relatorioTipo} exact component={PageRelatorioTipo} />
        <Route path={paths.relatorioSolicitacoes} exact component={PageRelatorioSolicitacoes} />
        <Route path={paths.relatorioStatus} exact component={PageRelatorioStatus} />
        <Route path={paths.relatorioListarRequerimentos} exact component={PageListarRequerimentos} />
        <Route path={paths.setorSistemaDetalhar} exact component={PageSetorDetalhar} />
        <Route path={paths.setorSistemaEditar} exact component={PageSetorEditar} />
        <Route path={paths.setorSistemaListar} exact component={PageSetorListar} />
        <Route path={paths.setorSistemaCadastrar} exact component={PageSetorCadastrar} />
        <Route path={paths.servicosSistemaEditar} exact component={PageServicosEditar} />
        <Route path={paths.servicosSistemaDetalhar} exact component={PageServicosDetalhar} />
        <Route path={paths.servicosSistemaListar} exact component={PageServicosListar} />
        <Route path={paths.servicosSistemaCadastrar} exact component={PageServicosCadastrar} />
        <Route path={paths.postosAtendimentoEditar} exact component={PagePostosAtendimentoEditar} />
        <Route path={paths.postosAtendimentoDetalhar} exact component={PagePostosAtendimentoDetalhar} />
        <Route path={paths.postosAtendimentoListar} exact component={PagePostosAtendimentoListar} />
        <Route path={paths.postosAtendimentoCadastrar} exact component={PagePostosAtendimentoCadastrar} />
        <Route path={paths.dicionario} exact component={PageDicionario} />
        <Route path={paths.privateRoot} exact component={PageHomeSupervisor} />
        <Route path={paths.detalharRequerimento} exact component={PageDetalhar} />
        <Route path={paths.listarAtendente} exact component={PageListarAtendente} />
        <Route path={paths.cadastroAtendente} exact component={PageCadastrarAtendente} />
        <Route path={paths.editarAtendente} exact component={PageEditarAtendente} />
        <Route path={paths.visualizarAtendente} exact component={PageVisualizarAtendente} />
        <Route path={paths.rotaAtendente} exact component={PageHomeAtendente} />
        <Route path={paths.requerimentos} exact component={PageRequerimento} />
        <Route path={paths.requerimentosListarContribuinte} exact component={PageRequerimentoListarContribuinte} />
        <Route path={paths.dadosCadastraisRedirect} exact component={PageDadosCadastrais} />
        <Route path={paths.cadastroContribuinte} exact component={PageDadosCadastraisCadastrar} />
        <Route path={paths.editarContribuinte} exact component={PageDadosCadastraisEditar} />
        <Route path={paths.visualizarContribuinte} exact component={PageDadosCadastraisVisualizar} />
        <Route path={paths.homeContribuinte} exact component={PageRequerimentoListarContribuinte} />
      </Switch>
    </>
  );
}
